const config = [
  {
    colId: 'materialNumber',
    headerName: 'Material Number',
    field: 'materialNumber',
    suppressHeaderMenuButton: true,
    width: 100,
    suppressMovable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      defaultOption: 'contains',
      maxNumConditions : 1,
      caseSensitive: false
    },
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    }
  },
  {
    colId: 'PDMNumber',
    headerName: 'PDM Number',
    field: 'PDMNumber',
    suppressHeaderMenuButton: true,
    width: 100,
    suppressMovable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      defaultOption: 'contains',
      maxNumConditions : 1,
      caseSensitive: false
    },
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    }
  },
  {
    colId: 'materialName',
    headerName: 'Material Name',
    field: 'materialName',
    suppressHeaderMenuButton: true,
    tooltipField: 'materialName',
    suppressMovable: true,
    cellStyle: { color: '#3498db' },
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      defaultOption: 'contains',
      maxNumConditions : 1,
      caseSensitive: false
    },
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    }
  },
  {
    colId: 'refId',
    headerName: 'Material ID',
    field: 'refId',
    suppressHeaderMenuButton: true,
    width: 100,
    suppressMovable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      defaultOption: 'contains',
      maxNumConditions : 1,
      caseSensitive: false
    },
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    }
  }
];
export default config;
